/* tslint:disable:no-var-requires */
import AppConfig from '../../config/AppConfig';

// const chineseLang = global.__TEST__ ? '' : require('../../image/flag/china.svg') as any;
// const frenchLang = global.__TEST__ ? '' : require('../../image/flag/france.svg') as any;
// const italianLang = global.__TEST__ ? '' : require('../../image/flag/italy.svg') as any;
// const spanishLang = global.__TEST__ ? '' : require('../../image/flag/spain.svg') as any;
// const thaiLang = global.__TEST__ ? '' : require('../../image/flag/th.svg') as any;
// const englishLang = global.__TEST__ ? '' : require('../../image/flag/uk.svg') as any;

const chineseLang = require('../../image/flag/china.svg') as string;
const frenchLang = require('../../image/flag/france.svg') as string;
const italianLang = require('../../image/flag/italy.svg') as string;
const spanishLang = require('../../image/flag/spain.svg') as string;
const thaiLang = require('../../image/flag/th.svg') as string;
const englishLang = require('../../image/flag/uk.svg') as string;
const icelandicLang = require('../../image/flag/is.svg') as string;

export interface ILanguage {
    languageId: string;
    locale: string;
    text: string;
    icon: string;
}

const config = {
    defaultLanguage: AppConfig.defaultLanguage,
    options: [
        {
            languageId: 'english',
            locale: 'en',
            text: 'English',
            icon: englishLang,
            rfc3066:'en-US'
        },
        {
            languageId: 'chinese',
            locale: 'zh',
            text: 'Chinese',
            icon: chineseLang,
            rfc3066:'zh-CN'
        },
        {
            languageId: 'chinese',
            locale: 'cn',
            text: 'Chinese',
            icon: chineseLang,
            rfc3066:'zh-CN'
        },
        {
            languageId: 'spanish',
            locale: 'es',
            text: 'Spanish',
            icon: spanishLang,
            rfc3066:'es-ES'
        },
        {
            languageId: 'french',
            locale: 'fr',
            text: 'French',
            icon: frenchLang,
            rfc3066:'fr-FR'
        },
        {
            languageId: 'italian',
            locale: 'it',
            text: 'Italian',
            icon: italianLang,
            rfc3066:'it-IT'
        },
        {
            languageId: 'thai',
            locale: 'th',
            text: 'Thai',
            icon: thaiLang,
            rfc3066:'th-TH'
        },
        {
            languageId: 'iceland',
            locale: 'is',
            text: 'Icelandic',
            icon: icelandicLang,
            rfc3066:'is-IS'
        }
    ]
};

export function getCurrentLanguage(lang): ILanguage {
    let selecetedLanguage = config.options[0];
    config.options.forEach(language => {
        if (language.locale === lang) {
            selecetedLanguage = language;
        }
    });
    return selecetedLanguage;
}

export default config;



// WEBPACK FOOTER //
// ./src/containers/LanguageSwitcher/config.ts